export default "__VITE_ASSET__Cgo2THlj__"